import { l } from '@manychat/manyui'

import { CancellationReasonType } from 'common/billing/interfaces/cancellationReasons'

type ReasonLabelsMap = Partial<Record<CancellationReasonType, ReturnType<typeof l.makeTranslate>>>

export const ReasonListLabels: ReasonLabelsMap = {
  [CancellationReasonType.TOO_EXPENSIVE]: l.makeTranslate('Too expensive'),
  [CancellationReasonType.CLIENT_CANCELLED]: l.makeTranslate('Client cancelled the project'),
  [CancellationReasonType.PAGE_PROBLEMS]: l.makeTranslate(
    'My page got banned / restricted by Meta',
  ),
  [CancellationReasonType.PAGE_SWITCH]: l.makeTranslate(
    'I’m switching my Pro subscription to another page',
  ),
  [CancellationReasonType.BAD_UNDERSTANDING]: l.makeTranslate(
    'I didn’t understand how to use the product',
  ),
  [CancellationReasonType.BAD_RESULT]: l.makeTranslate(
    'I didn’t get enough results (ROI, subscribers, etc.)',
  ),
  [CancellationReasonType.PLATFORM_SWITCH]: l.makeTranslate('I’m switching to another platform'),
  [CancellationReasonType.BAD_EXP]: l.makeTranslate(
    'I had a bad experience (bugs, delays, support, etc.)',
  ),
  [CancellationReasonType.BAD_PRODUCT]: l.makeTranslate('I never got around to using it'),
  [CancellationReasonType.OTHER_MAIN]: l.makeTranslate('Other'),
  [CancellationReasonType.PROJECT_COMPLETE]: l.makeTranslate(
    'I have finished this project/campaign',
  ),
  [CancellationReasonType.SUBSCRIPTION_PAUSE]: l.makeTranslate(
    'Just taking a break, will be back soon',
  ),
  [CancellationReasonType.OTHER]: l.makeTranslate('Other reason'),
  [CancellationReasonType.FB_EU_RESTRICTIONS]: l.makeTranslate("Facebook's restrictions in Europe"),
  [CancellationReasonType.WRONG_PRODUCT]: l.makeTranslate('Manychat is missing important features'),
  [CancellationReasonType.REMOVED_OTHER]: l.makeTranslate(
    'Feature I used was removed from Manychat (describe below)',
  ),
  [CancellationReasonType.REMOVED_SB]: l.makeTranslate(
    'Feature I used regularly was removed from Manychat: Subscription Broadcasting',
  ),
  [CancellationReasonType.REMOVED_MSG_CODE]: l.makeTranslate(
    'Feature I used regularly was removed from Manychat: Messenger Code',
  ),
  [CancellationReasonType.MAR4]: l.makeTranslate(
    'Mar 4 Facebook Policy updates disallow use cases that are important for me',
  ),
  [CancellationReasonType.DIDNT_GET_RESULTS]: l.makeTranslate(
    "I didn't get the results I expected",
  ),
  [CancellationReasonType.NOT_ENOUGH_ROI]: l.makeTranslate(
    "I didn't generate enough leads, sales, or subscribers",
  ),
  [CancellationReasonType.TOOK_TOO_MUCH_TIME]: l.makeTranslate(
    'Setting up Manychat took too much time or effort',
  ),
  [CancellationReasonType.NOT_ENOUGH_TIME]: l.makeTranslate(
    "I didn't have time to fully use Manychat for my business",
  ),
  [CancellationReasonType.NOT_FIT_BUSINESS_NEEDS]: l.makeTranslate(
    "Manychat wasn't a good fit for my business needs",
  ),
  [CancellationReasonType.NOT_MEET_EXPECTATIONS]: l.makeTranslate(
    "Manychat didn't meet my expectations in terms of performance or features",
  ),
  [CancellationReasonType.TOO_MANY_CONTACTS_BILLED]: l.makeTranslate(
    'Too many contacts billed were not generated through Manychat automation',
  ),
  [CancellationReasonType.DIDNT_GET_RESULTS_OTHER]: l.makeTranslate('Other (please share)'),
  [CancellationReasonType.COST]: l.makeTranslate("The cost didn't match my budget or expectations"),
  [CancellationReasonType.PRICE_TOO_HIGH]: l.makeTranslate(
    'The price was too high for my business',
  ),
  [CancellationReasonType.NOT_ENOUGH_VALUE]: l.makeTranslate(
    "I didn't see enough value for the cost",
  ),
  [CancellationReasonType.ANOTHER_BILLING_APPROACH]: l.makeTranslate(
    'I prefer a fixed price or pay-as-you-go option',
  ),
  [CancellationReasonType.NEEDED_MORE_FEATURES]: l.makeTranslate(
    'I needed more features or higher limits at the current price',
  ),
  [CancellationReasonType.PRICING_UNCLEAR]: l.makeTranslate(
    "The pricing model was unclear, confusing, or difficult to predict what I'd actually pay",
  ),
  [CancellationReasonType.COSTS_INCREASED]: l.makeTranslate(
    'Costs increased unexpectedly over time due to contact growth or automation usage',
  ),
  [CancellationReasonType.FORCED_TO_DELETE_CONTACTS]: l.makeTranslate(
    'I felt compelled to delete contacts regularly to keep costs manageable',
  ),
  [CancellationReasonType.PRICE_UPGRADES]: l.makeTranslate(
    'Price tier upgrades (due to growth) felt disproportionate to the value I received',
  ),
  [CancellationReasonType.COST_OTHER]: l.makeTranslate('Other (please share)'),
  [CancellationReasonType.SWITCHED_TOOL]: l.makeTranslate('I switched to another tool'),
  [CancellationReasonType.BETTER_FEATURES]: l.makeTranslate(
    'I found a tool with better features for my needs',
  ),
  [CancellationReasonType.MORE_AFFORDABLE]: l.makeTranslate('Another tool was more affordable'),
  [CancellationReasonType.BETTER_INTEGRATION]: l.makeTranslate(
    'My new tool connects better with my other software',
  ),
  [CancellationReasonType.BETTER_SUPPORT]: l.makeTranslate(
    'Another tool offers better support or customer service',
  ),
  [CancellationReasonType.MORE_AI_AUTOMATION]: l.makeTranslate(
    'The new tool has more automation options or AI capabilities',
  ),
  [CancellationReasonType.SWITCHED_TOOL_OTHER]: l.makeTranslate('Other (please share)'),
  [CancellationReasonType.TOO_COMPLICATED]: l.makeTranslate(
    'Manychat was too complicated or difficult to use',
  ),
  [CancellationReasonType.AUTOMATION_CONFUSING]: l.makeTranslate(
    'Setting up automation and flows was confusing',
  ),
  [CancellationReasonType.INTEGRATION_ISSUES]: l.makeTranslate(
    'I had trouble connecting Manychat with social accounts or my other tools',
  ),
  [CancellationReasonType.INTERFACE_DIFFICULT]: l.makeTranslate(
    'The interface was difficult to navigate',
  ),
  [CancellationReasonType.MANUAL_WORK_REQUIRED]: l.makeTranslate(
    'It required too much manual work to maintain or update',
  ),
  [CancellationReasonType.NEEDED_MORE_TEMPLATES]: l.makeTranslate(
    'I needed more pre-built templates or automation options',
  ),
  [CancellationReasonType.TOO_COMPLICATED_OTHER]: l.makeTranslate('Other (please share)'),
  [CancellationReasonType.SUPPORT_ISSUES]: l.makeTranslate(
    'I had issues with support or technical problems',
  ),
  [CancellationReasonType.TECHNICAL_PROBLEMS]: l.makeTranslate(
    "Manychat didn't work as expected (bugs, errors, performance issues)",
  ),
  [CancellationReasonType.SUPPORT_NOT_HELPFUL]: l.makeTranslate(
    "I couldn't get the help I needed from support",
  ),
  [CancellationReasonType.SUPPORT_SLOW]: l.makeTranslate(
    'Customer support response time was too slow',
  ),
  [CancellationReasonType.DOCUMENTATION_LACKING]: l.makeTranslate(
    "Manychat's documentation and resources weren't helpful enough",
  ),
  [CancellationReasonType.BILLING_ISSUES]: l.makeTranslate(
    'My inquiries about pricing or billing were not adequately resolved',
  ),
  [CancellationReasonType.ONGOING_ISSUES]: l.makeTranslate(
    'I had ongoing issues that were never fully resolved',
  ),
  [CancellationReasonType.SUPPORT_ISSUES_OTHER]: l.makeTranslate('Other (please share)'),
  [CancellationReasonType.NEEDS_CHANGED]: l.makeTranslate('My needs changed'),
  [CancellationReasonType.NO_LONGER_NEEDED]: l.makeTranslate(
    'I no longer need automation or messaging tools',
  ),
  [CancellationReasonType.BUSINESS_CHANGED]: l.makeTranslate(
    'My business closed, changed direction, or restructured',
  ),
  [CancellationReasonType.BUSINESS_NOT_SUPPORTED]: l.makeTranslate(
    "My business type (e.g., influencer, small business, creator) wasn't well-supported by the pricing structure",
  ),
  [CancellationReasonType.NOT_SUITABLE_FOR_BUSINESS]: l.makeTranslate(
    "Manychat doesn't work well for my type of business",
  ),
  [CancellationReasonType.MARKETING_STRATEGY_SHIFTED]: l.makeTranslate(
    'I shifted my marketing strategy and no longer need this type of tool',
  ),
  [CancellationReasonType.LOW_CUSTOMER_ENGAGEMENT]: l.makeTranslate(
    "My customers weren't engaging with my messages",
  ),
  [CancellationReasonType.NEEDS_CHANGED_OTHER]: l.makeTranslate('Other (please share)'),
  [CancellationReasonType.CLIENT_NO_LONGER_NEEDS]: l.makeTranslate(
    'I am canceling subscription because my client no longer needs it',
  ),
  [CancellationReasonType.CLIENT_DECIDED_TO_CANCEL]: l.makeTranslate(
    'My client decided to cancel Manychat, so I am canceling their subscription',
  ),
  [CancellationReasonType.CLIENT_SWITCHED_TOOL]: l.makeTranslate(
    'My client switched to another tool',
  ),
  [CancellationReasonType.CLIENT_NO_LONGER_NEEDED]: l.makeTranslate(
    "My client's business no longer needs automation or messaging tools",
  ),
  [CancellationReasonType.CLIENT_BUDGET_CHANGED]: l.makeTranslate(
    "My client's budget changed, and they can no longer afford the subscription",
  ),
  [CancellationReasonType.CLIENT_NO_LONGER_NEEDS_OTHER]: l.makeTranslate('Other (please share)'),
  [CancellationReasonType.SWITCHED_MANYCHAT_ACCOUNT]: l.makeTranslate(
    'I switched my subscription to another Manychat account',
  ),
}
